<template>
  <Message
    v-if="error"
    severity="error"
    size="small"
    variant="simple"
    class="field-error-message"
  >
    {{ error }}
  </Message>
</template>

<script setup lang="ts">
defineProps<{
  error?: string | boolean;
}>();
</script>

<style scoped>
.field-error-message {
  margin-top: 0.25rem;
}
</style>
